import { render, staticRenderFns } from "./ResetMetadata.vue?vue&type=template&id=3ab73e85"
import script from "./ResetMetadata.vue?vue&type=script&lang=js"
export * from "./ResetMetadata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports